import React from 'react';
import { useParams } from 'react-router-dom';
import { ImageAuditPage } from './ImageAuditPage';

export const ImageAuditPageWrapper: React.FC = () => {
  const { imageId } = useParams<{ imageId: string }>();

  return <ImageAuditPage key={imageId} imageId={imageId ?? null} />;
};
